import { Autocomplete } from '@react-google-maps/api';
import { css } from '@emotion/react';

import { useColors } from 'hooks/useColors';
import { IColors } from 'types/colors';
import { i18n } from 'lib/i18n';
import { useRef, useState } from 'react';
import { FilledInput } from '@material-ui/core';
import { checkIfGoogleMapsIsLoaded } from 'lib/google';

export const inputCss = (colors: IColors) => css`
	background: ${colors.bg_background_primary};
	color: ${colors.tx_text_teriaty};
	font-size: 1.6rem;
	line-height: 2rem;
	border: none;
	padding: 0;
	outline: none;
	width: 100%;
`;

const addressInputCss = (colors: IColors) => css`
	${inputCss(colors)}
`;

const inputPlaceHolderCss = (colors: IColors) => css`
	input::placeholder {
		color: ${colors.tx_text_teriaty};
	}
`;

const removeUnderlineCss = css`
	div::before {
		border-bottom: none !important;
	}
	div::after {
		border-bottom: none !important;
	}
`;

const autoCompleteCss = (colors: IColors) => css`
	${inputPlaceHolderCss(colors)}
	${removeUnderlineCss}
`;
interface GoogleAddressProps {
	onChange: (place: google.maps.places.PlaceResult) => void;
}

const GoogleAddress = (props: GoogleAddressProps) => {
	const [searchResult, setSearchResult] = useState<string>('');
	const autocompleteRef = useRef<google.maps.places.Autocomplete>();
	const { colors } = useColors();

	const isLoaded = checkIfGoogleMapsIsLoaded();

	const onLoad = (autocomplete: google.maps.places.Autocomplete) => {
		autocompleteRef.current = autocomplete;
	};

	const onPlaceChanged = () => {
		const autocomplete = autocompleteRef.current;
		if (autocomplete) {
			const place: google.maps.places.PlaceResult = autocomplete.getPlace();
			setSearchResult(place.formatted_address ?? '');
			props.onChange(place);
		}
	};

	if (!isLoaded) {
		return <div>Loading...</div>;
	}

	return (
		<div data-aid="google-autocomplete">
			<Autocomplete css={autoCompleteCss(colors)} onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
				<FilledInput
					onChange={(e: React.ChangeEvent) => setSearchResult((e.target as any).value)}
					value={searchResult}
					type="text"
					placeholder={i18n.googleAddressPlaceholder}
					css={addressInputCss(colors)}
				/>
			</Autocomplete>
		</div>
	);
};

export default GoogleAddress;
